var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_332_4423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_332_4423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25678 16.5834C4.88164 16.5834 4.56456 16.4539 4.30553 16.1949C4.04651 15.9358 3.91699 15.6188 3.91699 15.2436V4.75654C3.91699 4.3814 4.04651 4.06432 4.30553 3.80529C4.56456 3.54626 4.88164 3.41675 5.25678 3.41675H9.63803C9.79178 3.41675 9.92053 3.46821 10.0243 3.57112C10.1279 3.6739 10.1797 3.80154 10.1797 3.95404C10.1797 4.10654 10.1279 4.23564 10.0243 4.34133C9.92053 4.44716 9.79178 4.50008 9.63803 4.50008H5.25678C5.19262 4.50008 5.13387 4.52682 5.08053 4.58029C5.02706 4.63362 5.00033 4.69237 5.00033 4.75654V15.2436C5.00033 15.3078 5.02706 15.3665 5.08053 15.4199C5.13387 15.4733 5.19262 15.5001 5.25678 15.5001H15.7439C15.808 15.5001 15.8668 15.4733 15.9201 15.4199C15.9736 15.3665 16.0003 15.3078 16.0003 15.2436V10.8624C16.0003 10.7086 16.0517 10.5799 16.1545 10.4761C16.2574 10.3725 16.3851 10.3207 16.5376 10.3207C16.6901 10.3207 16.8192 10.3725 16.9249 10.4761C17.0307 10.5799 17.0837 10.7086 17.0837 10.8624V15.2436C17.0837 15.6188 16.9541 15.9358 16.6951 16.1949C16.4361 16.4539 16.119 16.5834 15.7439 16.5834H5.25678ZM16.0003 5.27404L8.95553 12.319C8.84012 12.4343 8.71588 12.4899 8.58283 12.4857C8.44991 12.4814 8.32303 12.4189 8.2022 12.2982C8.08151 12.1774 8.02116 12.0483 8.02116 11.9111C8.02116 11.7739 8.08151 11.6449 8.2022 11.524L15.2264 4.50008H13.042C12.8882 4.50008 12.7596 4.44869 12.656 4.34591C12.5522 4.243 12.5003 4.11529 12.5003 3.96279C12.5003 3.81029 12.5522 3.68119 12.656 3.5755C12.7596 3.46966 12.8882 3.41675 13.042 3.41675H16.4137C16.6049 3.41675 16.7644 3.48064 16.892 3.60841C17.0198 3.73605 17.0837 3.8955 17.0837 4.08675V7.45842C17.0837 7.61216 17.0322 7.74085 16.9293 7.84446C16.8265 7.94821 16.6989 8.00008 16.5464 8.00008C16.3939 8.00008 16.2648 7.94821 16.1591 7.84446C16.0532 7.74085 16.0003 7.61216 16.0003 7.45842V5.27404Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailOpenIcon);
export default __webpack_public_path__ + "static/media/detail-openIcon.3b9a409ebf10e76f54b1112712a05ae8.svg";
export { ForwardRef as ReactComponent };